import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ISpinnerState {
  show: boolean
}

@Injectable()
export class SpinnerService {
  private _spinnerSubject = new Subject();
  spinnerState = this._spinnerSubject.asObservable();

  show() {
    this._spinnerSubject.next(<ISpinnerState>{ show: true });
  }
  hide() {
    this._spinnerSubject.next(<ISpinnerState>{ show: false });
  }
}